export const UNRELIABLE_DOWNLOAD_MODAL_DISMISSED_STORAGE_KEY = 'unreliableDownloadModalDismissed';
export const UNRELIABLE_DOWNLOAD_MODAL_ID = 'unreliable-download-modal';
